var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.3333 3.33325H20.6666V6.66658H19.9999C18.5272 6.66658 17.3333 5.47268 17.3333 3.99992V3.33325Z",
    fill: "#FAB215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.3333 3.33325H14.6666V6.66658H13.9999C12.5272 6.66658 11.3333 5.47268 11.3333 3.99992V3.33325Z",
    fill: "#FAB215"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 0V0.666667C9.33325 2.13943 10.5272 3.33333 11.9999 3.33333H19.9999C21.4727 3.33333 22.6666 2.13943 22.6666 0.666667V0H9.33325Z",
    fill: "#FAB215"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 25.0653C15.1143 24.1087 15.4421 22.8855 16.3987 22.3333L22.7495 18.6666L23.7495 20.3986C24.3018 21.3552 23.9741 22.5784 23.0175 23.1307L16.6666 26.7974L15.6666 25.0653Z",
    fill: "url(#paint0_linear_887_4792)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3333 30.6667H6C8.20914 30.6667 10 28.8759 10 26.6667V6.66675H23.3333C25.5425 6.66675 27.3333 8.45761 27.3333 10.6667V26.6667C27.3333 28.8759 25.5425 30.6667 23.3333 30.6667ZM16.3987 22.3334C15.4421 22.8857 15.1144 24.1089 15.6667 25.0655L16.6667 26.7975L23.0175 23.1308C23.9741 22.5786 24.3019 21.3554 23.7496 20.3988L22.7496 18.6667L16.3987 22.3334ZM13.5979 11.6792C13.3283 11.2349 13.6481 10.6667 14.1678 10.6667H18.918C19.4377 10.6667 19.7575 11.2349 19.4879 11.6792L17.1128 15.5933C16.8533 16.0211 16.2325 16.0211 15.9729 15.5933L13.5979 11.6792Z",
    fill: "url(#paint1_linear_887_4792)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M4.66663 10.6667C4.66663 8.45761 6.45749 6.66675 8.66663 6.66675H9.99996V26.6667C9.99996 28.8759 8.2091 30.6667 5.99996 30.6667H4.66663V10.6667Z",
    fill: "url(#paint2_linear_887_4792)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4792",
    x1: 16.6666,
    y1: 26.6666,
    x2: 22.6666,
    y2: 18.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_887_4792",
    x1: 24.4889,
    y1: 30.6667,
    x2: 24.4889,
    y2: 6.66675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_887_4792",
    x1: 7.33329,
    y1: 6.66675,
    x2: 7.33329,
    y2: 30.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/16.e12edf6c023243572112ec9316e57fc0.svg";
export { ForwardRef as ReactComponent };